import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Home_about from "./home-about/Home_about";
import Why_nutricos from "./why-nutricos/Why_nutricos";
import Related_category from "./related-category/Related_category";
import Why_clients from "./why-clients/Why_clients";
import Services from "./services/Services";
import Enquire_now from "./enquire_now/Enquire_now";
import All_video from "./all-video/All_video";
import Testimonials from "./testimonials/Testimonials";
import Aim_To_Scale_Up from "./aim_to_scale_up/Aim_To_Scale_Up";
import Our_Philosophy from "./our-philosophy/Our_Philosophy";
import NutricosBanner from "./nutricos_banner/Nutricos_Banner";
import Meet_Section from "./meet_section/Meet_Section";
import Video_Section from "./video-section/Video_Section";
import Counter from "./counter/Counter";
import Why from "../home/why/Why";
import ExploreCategory from "./explorecategory/ExploreCategory";
import WhatsappChatbot from "../common-components/chatbot/Chatbot";
import DealerNetwork from "../dealernetwork/DealerNetwork";
import Explore_Products from "./explore_products/Explore_Products";
import Blogs from "../blogs/Blogs";


function Home() {
  return (
    <>
    <WhatsappChatbot/>
      <Banner />
         <Counter />
             <Testimonials />
  
      <ExploreCategory />
      <Why />
       <Explore_Products/>
      <Meet_Section />

      <Video_Section />

      <Our_Philosophy />

      {/* <Services /> */}
      {/* <Home_about /> */}
      {/* <Related_category /> */}
      {/* <Why_nutricos /> */}

      {/* <Home_about /> */}
      {/* <Related_category /> */}
      {/* <Why_clients /> */}
      <NutricosBanner />
      <DealerNetwork/>
   
      {/* <All_video /> */}
  
       
      {/* <Aim_To_Scale_Up /> */}
      {/* <Aim_To_Scale_Up /> */}

      {/* <Enquire_now /> */}
      <Blogs/>
   
    </>
  );
}

export default Home;
